import { useMutation } from '@tanstack/react-query'

import * as api from '../api'
import useInvalidate from '../useInvalidate'

export default function useMarkNotificationsRead() {
  const invalidate = useInvalidate()

  return useMutation({
    mutationFn: async ({ notificationUuids }: { notificationUuids: string[] }) => {
      await api.post(`notification/mark-read`, notificationUuids)
      await invalidate.notifications()
      await invalidate.notificationCount()
    },
  })
}
